export default __webpack_public_path__ + "static/Punk-a97c70374ab3ed9b875d551e5b44529d.png";